import React from 'react';
import { motion } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';
import '../../styles/kromaic-theme.css';

const Tag = ({
                 label,
                 active = false,
                 removable = false,
                 onRemove,
                 onClick,
                 color,
                 icon: Icon,
                 size = 'medium'
             }) => {
    const handleClick = (e) => {
        if (onClick) {
            onClick(e);
        }
    };

    const handleRemove = (e) => {
        e.stopPropagation();
        if (onRemove) {
            onRemove();
        }
    };

    const sizes = {
        small: {
            padding: '0.25rem 0.75rem',
            fontSize: '0.75rem'
        },
        medium: {
            padding: '0.5rem 1rem',
            fontSize: '0.875rem'
        },
        large: {
            padding: '0.75rem 1.25rem',
            fontSize: '1rem'
        }
    };

    const currentSize = sizes[size];

    return (
        <motion.div
            className={`tag ${active ? 'active' : ''}`}
            onClick={handleClick}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: currentSize.padding,
                fontSize: currentSize.fontSize,
                backgroundColor: active ? (color || 'var(--champagne-gold)') : 'var(--soft-ivory)',
                color: active ? 'var(--deep-charcoal)' : 'var(--charcoal-80)',
                borderRadius: 'var(--border-radius-full)',
                border: `1px solid ${active ? (color || 'var(--champagne-gold)') : 'var(--nude-beige)'}`,
                cursor: onClick ? 'pointer' : 'default',
                fontWeight: 500,
                transition: 'all var(--transition-fast)',
                userSelect: 'none'
            }}
        >
            {Icon && <Icon size={currentSize.fontSize} />}
            <span>{label}</span>

            {removable && (
                <motion.div
                    className="tag-remove"
                    onClick={handleRemove}
                    whileHover={{ scale: 1.2 }}
                    whileTap={{ scale: 0.9 }}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginLeft: '0.25rem',
                        cursor: 'pointer'
                    }}
                >
                    <FaTimes size={currentSize.fontSize} />
                </motion.div>
            )}
        </motion.div>
    );
};

export default Tag;